import { IGlobalState } from '../../../Root/store/appReducer'
import { UserCompanyDto } from '../../../services/api.types'
import { CompanyListItem } from '../../SuperAdmin/store/SuperAdminReducer'

function companyListItemToUserCompanyDto(item: CompanyListItem): UserCompanyDto {
  return {
    companyId: item.companyId,
    companyName: item.companyName,
    employees: item.employees,
    plan: item.plan,
    scope: item.scope,
    startAt: item.startAt,
    paidUntil: item.paidUntil,
    active: true,
    country: '',
    countryRequired: false,
    createdAt: 0,
    divisionId: '' as any,
    divisionName: '',
    divisionRequired: item.divisionRequired ?? false,
    hideRankingView: item.hideRankingView ?? false,
    hideStatisticsView: item.hideStatisticsView ?? false,
    reportRequired: item.reportRequired ?? false,
    reportRequiredForUsers: item.reportRequiredForUsers ?? false,
    id: '' as any,
    ownerCompanyId: '' as any,
    ownerUserId: '' as any,
    publicGoalsEnabled: false,
    userGoalsEnabled: false,
    userId: '' as any,
    userLimit: null as any,
    brandLogoUrl: '',
    trialStartDate: '',
    trialEndDate: '',
    salesperson: '',
    salespersonEmail: '',
    passwordPolicy: '',
    passwordMinLength: 0,
    minTeamSize: (item.minTeamSize ?? '') as any,
    maxTeamSize: (item.maxTeamSize ?? '') as any,
    teamSelectionLocked: item.teamSelectionLocked ?? false,
    userCreatedTeams: item.userCreatedTeams ?? false,
    autoJoinEnabled: false,
    teamSwitchingDisabled: item.teamSwitchingDisabled ?? false,
    customPolicyUrl: '',
    customPolicyTitle: '',
    divisionIds: '',
  }
}

// Memoize to avoid creating new array references on every selector call
let _cachedUserCompanies: UserCompanyDto[] | null = null
let _cachedUserCompaniesInput: UserCompanyDto[] | null = null
let _cachedUserCompaniesTargetCompany: CompanyListItem | null = null

let _cachedManagedCompanies: UserCompanyDto[] | null = null
let _cachedManagedCompaniesInput: UserCompanyDto[] | null = null
let _cachedManagedCompaniesTargetCompany: CompanyListItem | null = null

function injectTargetCompanyMemoized(
  companies: UserCompanyDto[],
  state: IGlobalState,
  cache: 'user' | 'managed',
): UserCompanyDto[] {
  const targetCompany = state.superAdmin?.targetCompany
  if (!state.auth.isSuperAdmin || !targetCompany) {
    return companies
  }
  const existingCompany = companies.find((c) => c.companyId === targetCompany.companyId)

  if (cache === 'user') {
    if (
      _cachedUserCompaniesInput === companies &&
      _cachedUserCompaniesTargetCompany === targetCompany &&
      _cachedUserCompanies
    ) {
      return _cachedUserCompanies
    }
    _cachedUserCompaniesInput = companies
    _cachedUserCompaniesTargetCompany = targetCompany
    _cachedUserCompanies = [existingCompany || companyListItemToUserCompanyDto(targetCompany)]
    return _cachedUserCompanies
  } else {
    if (
      _cachedManagedCompaniesInput === companies &&
      _cachedManagedCompaniesTargetCompany === targetCompany &&
      _cachedManagedCompanies
    ) {
      return _cachedManagedCompanies
    }
    _cachedManagedCompaniesInput = companies
    _cachedManagedCompaniesTargetCompany = targetCompany
    _cachedManagedCompanies = [existingCompany || companyListItemToUserCompanyDto(targetCompany)]
    return _cachedManagedCompanies
  }
}

//export const userActivitySelector = (state: IGlobalState) => state.settings.activity
//export const userBadgeSelector = (state: IGlobalState) => state.settings.badges
//export const companyDivisionsSelector = (state: IGlobalState) => state.settings.divisions
export const companyDivisionsSelector = (state: IGlobalState) => state.settings.companyDivisions
export const companyCountriesSelector = (state: IGlobalState) => state.settings.countries
export const userDtoSelector = (state: IGlobalState) => state.auth.userDto
export const userCompaniesSelector = (state: IGlobalState) =>
  injectTargetCompanyMemoized(state.auth.userCompanies, state, 'user')
export const managedCompaniesSelector = (state: IGlobalState) =>
  injectTargetCompanyMemoized(state.auth.managedCompanies, state, 'managed')
export const getJoinCompanyLoading = (state: IGlobalState) => state.settings.joinCompanyLoading
export const getJoinedCompanyId = (state: IGlobalState) => state.settings.joinedCompanyId
export const getUserCompanyProfileLoading = (state: IGlobalState) => state.settings.userCompanyProfileLoading
export const getChangePasswordFailCount = (state: IGlobalState) => state.settings.changePasswordFailCount
export const getChangePasswordOldPasswordError = (state: IGlobalState) => state.settings.changePasswordOldPasswordError
